import { render, staticRenderFns } from "./admin-settings-modal___1.vue?vue&type=template&id=81a125e0&scoped=true"
import script from "./admin-settings-modal___1.vue?vue&type=script&lang=js"
export * from "./admin-settings-modal___1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a125e0",
  null
  
)

export default component.exports